import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { BUSINESS, waLink } from "@/data/site";

export const FinalCta = () => {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 radial-red" aria-hidden="true" />
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Ready when you are</Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 text-4xl sm:text-5xl md:text-6xl font-heading font-extrabold tracking-tighter leading-[0.95]">
            Let's build a website that grows your business
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-6 text-muted-foreground text-lg max-w-2xl mx-auto">
          Get a free custom mockup of your new website. No commitment, no cost — just clarity on what's possible.
        </Reveal>
        <Reveal delay={0.15} className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <motion.a
            href={waLink(`Hi ${BUSINESS.name}, I'd like a free website mockup.`)}
            target="_blank" rel="noopener noreferrer"
            whileTap={{ scale: 0.97 }}
            data-testid="final-cta-mockup"
            className="group inline-flex items-center gap-2 rounded-full bg-primary hover:bg-[#c81f1f] text-primary-foreground font-semibold px-7 py-4 transition-colors"
          >
            Get Free Website Mockup
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </motion.a>
          <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="final-cta-call"
            className="inline-flex items-center gap-2 rounded-full border border-border bg-white hover:border-foreground/30 font-semibold px-7 py-4 transition-colors">
            <MessageCircle className="w-4 h-4 text-primary" /> {BUSINESS.phoneDisplay}
          </a>
        </Reveal>
        <Reveal delay={0.2} className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          <span>No credit card</span>
          <span>·</span>
          <span>Reply within 24 hrs</span>
          <span>·</span>
          <span>Serving {BUSINESS.serviceArea}</span>
        </Reveal>
      </div>
    </section>
  );
};
